
import React from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TaskTemplate {
  id: string;
  title: string;
  description: string | null;
  hebrew_title?: string | null;
  hebrew_description?: string | null;
}

interface TaskTemplateSelectorProps {
  onSelect: (template: TaskTemplate) => void;
}

export const TaskTemplateSelector = ({ onSelect }: TaskTemplateSelectorProps) => {
  const { data: templates = [], isLoading } = useQuery({
    queryKey: ['taskTemplates'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('task_templates')
        .select('*')
        .order('template_type', { ascending: false }) // Show custom templates first
        .order('title');

      if (error) throw error;
      return data as TaskTemplate[];
    },
  });

  const handleSelect = (templateId: string) => {
    const template = templates.find(t => t.id === templateId);
    if (template) {
      onSelect(template);
    }
  };

  if (isLoading) {
    return <div>Loading templates...</div>;
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="taskTemplate">Select Task Type</Label>
      <Select onValueChange={handleSelect}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Choose a task type" />
        </SelectTrigger>
        <SelectContent>
          <ScrollArea className="h-[200px]">
            {templates.map((template) => (
              <SelectItem key={template.id} value={template.id}>
                {template.title}
              </SelectItem>
            ))}
          </ScrollArea>
        </SelectContent>
      </Select>
    </div>
  );
};
